import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=9ea4ef0e&"
import script from "./WordList.vue?vue&type=script&lang=js&"
export * from "./WordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports